import { GrowthBook } from '@growthbook/growthbook';
import { v4 } from 'uuid';
import { detectDevice } from './detect-device.js';
import { cookieName } from './constants.js';

function growthbookMiddleware(growthbookContext, { growthbookAttributes = {} } = {}) {
    return (req, res, next) => {
        let deviceId = req.cookies[cookieName];
        if (deviceId === undefined) {
            const newId = v4();
            const expires = new Date();
            expires.setFullYear(expires.getFullYear() + 2);
            res.cookie(cookieName, newId, {
                expires,
                path: '/',
                sameSite: 'lax',
                secure: true,
            });
            deviceId = newId;
        }
        const growthbook = new GrowthBook(growthbookContext);
        const userAgent = req.headers['user-agent'];
        const platform = detectDevice(userAgent);
        const attributes = {
            ...growthbookAttributes.channel,
            ...growthbookAttributes.user,
            growthbook_id: deviceId,
            platform,
        };
        growthbook.setAttributes(attributes);
        // Clean up at the end of the request
        res.on('close', () => growthbook.destroy());
        req.growthbook = growthbook;
        // Wait for features to load (will be cached in-memory for future requests)
        growthbook.init({ timeout: 1000 }).then(() => next());
    };
}

export { growthbookMiddleware };
//# sourceMappingURL=growthbook-server.js.map
